import React, { useCallback } from 'react';
import { View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { AppView } from 'design-system';
import Button from 'design-system/Button';
import EmojiText from 'design-system/EmojiText';
import MoneyInputField from 'design-system/MoneyInputField';
import StatusBar from 'design-system/StatusBar';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useStyles from 'hooks/useStyles';
import { InternalTransfer } from 'features/transfers/types';
import createStyleSheets from 'utils/createStyleSheets';
import { formatAmount, formatDate } from 'utils/formatting';
import { goBackToTopWithStops } from 'utils/navigationv6';
const strings = {
    done: 'Close',
    title: 'Completed',
    fundSubTitle: 'Your transfer was successful',
    withdrawSubtitle: 'Your withdrawal was successful',
};
const InternalTransferSuccessScreen = ({ route, navigation }) => {
    const type = route.params?.type;
    const date = route.params?.date;
    const amount = route.params?.amount;
    const hasFundedPot = useAppSelector((state) => state.pots.hasFundedPot);
    const colors = useColors();
    const onDone = useCallback(() => {
        if (!hasFundedPot) {
            goBackToTopWithStops(navigation, ['Report']);
            return;
        }
        navigation.pop();
    }, [hasFundedPot]);
    const styles = useStyles(styleSet);
    const paddingBottom = useMarginBottom('paddingBottom', undefined, styles.container);
    return (<AppView>
      <View style={paddingBottom}>
        <StatusBar barStyle="dark-content" animated/>
        <View style={styles.textContainer}>
          <EmojiText fontSize={rem(72)}>🙌</EmojiText>
          <Text Text-32 style={styles.title}>
            {strings.title}
          </Text>
          <Text TextThin-14 Secondary centered style={styles.subtitle}>
            {type === InternalTransfer.fund ? strings.fundSubTitle : strings.withdrawSubtitle}
          </Text>
          <MoneyInputField color={colors.text.primary}>{formatAmount(amount)}</MoneyInputField>
          <Text Text-16 Secondary>
            {formatDate(date.toISOString())}
          </Text>
        </View>
        <Button brand title={strings.done} onPress={onDone}/>
      </View>
    </AppView>);
};
const styleSet = createStyleSheets(() => ({
    container: {
        flex: 1,
        alignItems: 'center',
        paddingHorizontal: rem(16),
    },
    textContainer: {
        flex: 1,
        alignItems: 'center',
        marginBottom: rem(40),
        justifyContent: 'center',
    },
    title: {
        marginTop: rem(16),
    },
    subtitle: {
        marginBottom: rem(3),
    },
}));
export default InternalTransferSuccessScreen;
